<template>
	<div class="zona">
		<div class="muoversi" id="muoversi">
			<h3>Muoversi in zona</h3>
			<p>
				Un piccolo parcheggio pubblico libero davanti casa e un grande parcheggio pubblico libero distante due minuti a
				piedi.
			</p>
		</div>

		<div class="posizione">
			<h3>Dove ti troverai</h3>
			<p>
				Sciacca, Sicilia, Italia Posizione centralissima, ma appartata. In solo 4 minuti a piedi sarete nella piazza
				principale di Sciacca, una meravigliosa terrazza affacciata sul Mar Mediterraneo di Sicilia. A due minuti da
				casa a piedi: ristoranti, negozi di alimentari, bar, pizzerie, farmacia, cinema multisala con annesso cinema
				all'aperto in uno splendido giardino di aranci. Ogni sabato a due minuti da casa il più grande MERCATO di merci
				varie della zona. A pochi minuti di auto da casa nostra, potrete trovare due “MERCATI DEL CONTADINO” che vendono
				ottime frutta e verdura siciliane di produzione locale e prodotti tipici, da portarvi a casa o da cucinare qui.
				Tutta la città con le PASTICCERIE SICILIANE e le gelaterie e i negozi di CERAMICA ARTIGIANALE sono a vostra
				disposizione. Potrete passare delle splendide serate scegliendo nel cartellone delle tante manifestazioni
				estive.
			</p>

			<img src="../assets/img/dove_ti_troverai.jpeg" alt="" />

			<p>
				Tutte le mattine dopo aver fatto colazione alla siciliana con una profumatissima granita di limone, potrete
				scegliere una giornata al mare in una delle DIECI SPIAGGE diverse di Sciacca, tutte raggiungibili in 10 minuti
				di auto. Potrete pranzare e cenare in uno dei numerosissimi ristoranti della città, tutti rinomati per il PESCE
				straordinariamente gustoso pescato dalla flotta peschereccia di Sciacca. Da non perdere un'escursione in barca
				nel mare del canale di Sicilia alla scoperta dell'isola Ferdinandea.
			</p>
		</div>

		<!-- <div class="museo" :class="{ mobile: viewport }">
			<div class="left-cont">
				<h3>Museo dei 5 Sensi</h3>
				<p>
					Lorem ipsum dolor sit amet consectetur, adipisicing elit. Tempora quisquam explicabo commodi quae vitae nulla
					laudantium fugiat, provident qui. Veniam esse deleniti beatae porro nemo sunt fugit, laudantium libero velit
					saepe in quidem natus voluptates non magnam neque earum officiis! Impedit velit consequuntur est cupiditate
					ipsa ipsum, dolorum possimus harum!
				</p>
			</div>

			<div class="right-cont">
				<img src="#!" alt="" />
			</div>
		</div> -->

		<div class="dintorni">
			<h3>Nei Ditorni</h3>
			<p>
				Saremo sempre disponibili per consigliarvi un'escursione in una delle meravigliose mete della Sicilia: a 50
				minuti Agrigento, con la VALLE DEI TEMPLI patrimonio mondiale dell'UNESCO; a 25 minuti la straordinaria
				SELINUNTE, con i suoi templi e l'area archeologica più vasta d'Europa; a 60 minuti PALERMO, vera capitale
				mediterranea e anch'essa patrimonio mondiale dell'UNESCO insieme alla vicina MONREALE. Siamo vicinissimi a
				Sambuca il BORGO DEI BORGHI d'Italia 2016. Eccezionali nella loro unicità grotte di San Calogero dove potrete
				visitare le grotte con vapori termali naturali. Sciacca è dotata di tutti i servizi pubblici: Ospedale, autobus
				urbani e extraurbani, commissariato di Polizia, Vigili del fuoco. I nostri aeroporti di riferimento sono:
				Palermo e Trapani raggiungibili in poco più di un'ora. (C) Apartaments Sciacca Sicily -RIPRODUZIONE RISERVATA
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ZonaComp',
	data() {
		return {
			viewport: false,
		};
	},
	methods: {
		viewFunction() {
			if (window.innerWidth <= 1090) {
				this.viewport = true;
			} else {
				this.viewport = false;
			}
		},
	},
	mounted() {
		window.addEventListener('resize', this.viewFunction);
	},
	unmounted() {
		window.removeEventListener('resize', this.viewFunction);
	},
};
</script>

<style scoped lang="scss">
h3 {
	font-weight: bold;
}
.zona {
	width: 100%;
	// background-color: aquamarine;
	margin-top: -2vw;
	text-align: center;
	padding-top: 2vw;
	font-size: 1.5em;

	.muoversi {
		background-color: #78b0d3;
	}

	.posizione {
		// background-color: bisque;

		img {
			max-width: 100%;
			max-height: 400px;
			background-color: white;
			border-radius: 20px;
		}
	}

	.museo {
		display: flex;
		background-color: #78b0d3;

		.right-cont,
		.left-cont {
			width: 50%;
			border-radius: 20px;
			padding: 1em;
		}

		.right-cont {
			img {
				width: 200px;
				height: 200px;
				background-color: white;
				border-radius: 20px;
			}
		}
	}

	.museo.mobile {
		flex-direction: column;
		.right-cont,
		.left-cont {
			width: 100%;
			border-radius: 20px;
			padding: 1em;
		}
	}
}

.zona > * {
	// border: 1px solid black;
	padding: 2vw;
}
</style>
